const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsMobile = { name: 'Mobile', pathName: null }

export default [
  {
    path: '/mobile',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: 'ofertas',
        title: 'Ofertas do aplicativo',
        component: () => import('@/modules/mobile/ofertas/views/pages/Ofertas.vue'),
        meta: {
          title: 'Ofertas do aplicativo',
          requiredModules: ['mobile'],
        },
        children: [
          {
            path: '',
            redirect: { name: 'mobile-ofertas-produtos-edicao' },
          },
          {
            path: 'produtos',
            redirect: { name: 'mobile-ofertas-produtos-edicao' },
          },
          {
            path: 'produtos/edicao',
            name: 'mobile-ofertas-produtos-edicao',
            component: () => import('@/modules/mobile/ofertas/views/pages/Produtos.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              requiredModules: ['mobile'],
              title: 'Ofertas do aplicativo',
              requiredUserPermissions: ['mobile/ofertas/produtos/edicao'],
            },
          },
          {
            path: 'produtos/edicao-lojas-franquia',
            component: () => import('@/modules/mobile/ofertas/views/pages/Produtos.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              requiredModules: ['mobile'],
              title: 'Ofertas do aplicativo',
              requiredUserPermissions: ['mobile/ofertas/produtos/edicao-lojas-franquia'],
            },
          },
          {
            path: 'destaques',
            component: () => import('@/modules/mobile/ofertas/views/pages/Destaques.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              requiredModules: ['mobile'],
              requiredUserPermissions: ['mobile/ofertas/destaques'],
              title: 'Ofertas em destaque',
            },
          },
          {
            path: 'destaques/editar/:type',
            component: () => import('@/modules/mobile/ofertas/views/pages/EditarDestaques.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              requiredModules: ['mobile'],
              requiredUserPermissions: ['mobile/ofertas/destaques'],
              title: 'Ofertas em destaque',
            },
          },
        ],
      },
    ],
  },
]
